import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Header} from 'shells/typography/header';
import {Subheader} from 'shells/typography/subheader';

type Props = {
    header: string;
    subheader: string;
    icon: React.ComponentType<any>;
    children: React.ReactNode;
};

export function SmallModalContent(props: Props) {
    const Icon = props.icon;

    return (
        <StackLegacy spacing={16}>
            <StackLegacy spacing={8} alignCenter={true} isHorizontal={true}>
                <Icon size={21} alignCenter={true} />
                <Header>{props.header}</Header>
            </StackLegacy>
            <Subheader>{props.subheader}</Subheader>
            {props.children}
        </StackLegacy>
    );
}
